import React, { Component } from 'react';
import SideNav from 'react-simple-sidenav';
import { Link } from 'react-router-dom';
import { NavItem } from 'reactstrap';

class AdminMenu extends Component {
    
    links = [
        <Link to="/add-manufacturer" onClick={(e)=>{this.hideIt();}}> Add Manufacturer </Link>,
        <Link to="/add-robot" onClick={(e)=>{this.hideIt();}}> Add Product </Link>,
        <Link to="/add-news" onClick={(e)=>{this.hideIt();}}> Add News </Link>,
        <Link to="/manufacturers-list" onClick={(e)=>{this.hideIt();}}> Manufacturers List </Link>,
        <Link to="/robots-list" onClick={(e)=>{this.hideIt();}}> Robots List </Link>,
        <Link to="/news-list" onClick={(e)=>{this.hideIt();}}> News List </Link>
    ];

    hideIt=()=>{
        this.setState({
            showNav:false
        });
    }

    state = {
        showNav:false
    };

    render() {
        return (
            <NavItem>
                <Link
                    className="nav-link"
                    to="/"
                    onClick={(e)=>{
                        e.preventDefault();
                        this.setState({showNav:true});
                }}>Admin</Link>
                <SideNav
                    showNav={this.state.showNav}
                    onHideNav={()=>{this.setState({showNav:false})}} 
                    items={this.links}
                    title="Admin Menu"
                />
            </NavItem>
        );
    }
}

export default AdminMenu;


// WEBPACK FOOTER //
// ./src/components/header/adminmenu.js